export default __webpack_public_path__ + "static/media/AppraisalSystemTrans.0824e522.png";